import { useContext } from "react";
import { Link, useRouteMatch } from "react-router-dom";

import { IStudyMatchParams } from "../types";
import { StudyDataContext } from "..";
import { ProjectDataContext } from "../../projects/project";

import styles from "./title.module.css";

export default function StudieTitle() {
  const { params } = useRouteMatch<IStudyMatchParams>();
  const { projectId } = params;

  const projectData = useContext(ProjectDataContext);
  const studyData = useContext(StudyDataContext);

  console.dir(projectData);

  const groupId = projectData?.groupId;
  const groupName = projectData?.groupName;

  return (
    <h3 className={styles.title} data-testid="projects_study_title">
      <Link className={styles.projectLink} to="/groups/">
        Your Groups
      </Link>
      &nbsp;/&nbsp;
      <Link className={styles.projectLink} to={`/groups/${groupId}`}>
        {groupName}
      </Link>
      &nbsp;/&nbsp;
      <Link className={styles.projectLink} to={`/projects/${projectId}`}>
        {projectData?.name}
      </Link>
      &nbsp;/&nbsp;
      <span>{studyData?.displayName}</span>
    </h3>
  );
}
